import React from 'react'
import icon from '../../../assets/icon/excel.svg'

const IconExcel = () => {
  return <img src={icon} alt="excel-download" width="30px" height="30px" />
}

export default IconExcel
